const STORAGE_KEY = 'incyia.securityNav'
export const SECURITY_NAV_EVENT = 'incyia-security-nav'

export type SecurityNavContext = {
  norm?: string
  familyId?: string
  familyLabel?: string
  controlId?: string
  controlLabel?: string
}

function emit() {
  try {
    window.dispatchEvent(new Event(SECURITY_NAV_EVENT))
  } catch {
    // ignore
  }
}

export function readSecurityNav(): SecurityNavContext {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return {}
    return JSON.parse(raw) as SecurityNavContext
  } catch {
    return {}
  }
}

export function writeSecurityNav(patch: SecurityNavContext) {
  try {
    const next = { ...readSecurityNav(), ...patch }
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next))
    emit()
  } catch {
    // ignore quota / private mode
  }
}

export function subscribeSecurityNav(listener: () => void) {
  window.addEventListener(SECURITY_NAV_EVENT, listener)
  return () => window.removeEventListener(SECURITY_NAV_EVENT, listener)
}
